import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Modal } from 'bootstrap';
import { User } from 'src/app/interfaces/user';
import { StateService } from 'src/app/services/state.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-import-user-selector',
  templateUrl: './import-user-selector.component.html',
  styleUrls: ['./import-user-selector.component.scss'],
})
export class ImportUserSelectorComponent implements OnInit {
  @Output() modalHidden: EventEmitter<any> = new EventEmitter();
  users?: User[];
  searchText: string = '';

  constructor(
    private userService: UserService,
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    this.getUsers();
  }

  getUsers() {
    this.userService.getAllUsers().subscribe({
      next: (users: any) => {
        this.users = users.users;
      },
    });
  }

  search() {
    this.userService.filterUsers(`name=${this.searchText}`).subscribe({
      next: (response: any) => {
        this.users = response.users;
      },
    });
  }

  openImportRoutineSelectorModal(user: User) {
    this.stateService.openModal.hide();

    const importRoutineSelectorModal = new Modal('#importObjectsSelectorModal');
    this.stateService.openModal = importRoutineSelectorModal;

    this.stateService.updateSelectedImportuser(user);

    importRoutineSelectorModal.show();

    const importRoutineSelectorModalElement = document.getElementById(
      'importObjectsSelectorModal'
    );

    importRoutineSelectorModalElement?.addEventListener(
      'hide.bs.modal',
      (ev: Event) => {
        this.modalHidden.emit();
      }
    );
  }

  closeModal() {
    this.stateService.openModal.hide();

    this.stateService.selectedDiet = undefined;
    this.stateService.selectedRoutineGroup = undefined;
  }
}
